import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import BenchmarkingService from "@app/overviews/network-benchmarking-dashboard/benchmarkingService";
import { BenchmarkingLineOfBusinessEnum } from "@app/overviews/network-benchmarking-dashboard/filters/shared/BenchmarkingLineOfBusinessEnum";

export interface BenchmarkingLinesOfBusinessResult {
  isLoading: boolean;
  linesOfBusiness: BenchmarkingLineOfBusinessEnum[];
}

export const BENCHMARKING_LINES_OF_BUSINESS_QUERY_KEY_PREFIX = "benchmarking-lines-of-business";

export const useBenchmarkingLinesOfBusiness = (): BenchmarkingLinesOfBusinessResult => {
  const benchmarkingService = useMemo(() => new BenchmarkingService(), []);

  const queryResult = useQuery<BenchmarkingLineOfBusinessEnum[]>({
    queryFn: ({ signal }) => benchmarkingService.getBenchmarkingLinesOfBusiness(signal),
    queryKey: [BENCHMARKING_LINES_OF_BUSINESS_QUERY_KEY_PREFIX],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    isLoading: queryResult.isFetching,
    linesOfBusiness: queryResult.data ?? [],
  };
}

export default useBenchmarkingLinesOfBusiness;
